wbApp.controller('LeadsDetailCtrl', ['$scope', '$modal', '$translate', '$q', 'leadSvc', 'notRegisteredUserSvc', 'studentSvc', 'userSvc', 
function ($scope, $modal, $translate, $q, leadSvc, notRegisteredUserSvc, studentSvc, userSvc) {

    $scope.model = $scope.model || {}; // Full lead object
    $scope.modelOrig = {};
    $scope.isDisabled = true;

    $scope.user = {};
    $scope.students = [];

    $scope.notRegisteredUserInfo = null;
    $scope.notRegisteredUserInfoOrig = null;

    function loadUser() {
        return $q(function (success, reject) {

            var promisses = [];
            promisses.push(userSvc.getByIDFull($scope.model.userId).$promise);
            if (!!$scope.model.studentIds && $scope.model.studentIds.length > 0) {
                promisses.push(studentSvc.getAllByUserIDAsync($scope.model.userId).$promise);
            }

            $q.all(promisses).then(function (data) {
                $scope.user = data[0];
                if (data.length > 1) {
                    var students = data[1];
                    $scope.students = _.intersectionWith(students, $scope.model.studentIds, function (arrVal, othVal) {
                        return arrVal.id == othVal;
                    });

                    _.forEach($scope.students, function (e) {
                        e.fullName = String.prototype.fullName(e.name, e.middlename, e.surname);
                    });
                }

                success();
            }, function (error) {
                reject(error);
            });
        });
    }

    function loadData(leadId) {
        $scope.isLoading = true;

        function finalizeLoading()
        {
            if ($scope.model.status == 1) {
                $scope.detailError = { errors: [{ message: $translate.instant('TXT_ERROR_LEAD_ALREADY_CONVERTED') }] };
                $scope.isSaving = false;
                $scope.isDisabled = true;
            } else {
                $scope.isDisabled = false;
            }
            $scope.isLoading = false;
        }

        leadSvc.getById(leadId).$promise.then(function (data) {

            $scope.model = data;
            $scope.modelOrig = angular.copy($scope.model);

            if ($scope.model.isNotRegisteredUser)
            {                
                notRegisteredUserSvc.getById($scope.model.userId).$promise.then(function (user) {

                    $scope.notRegisteredUserInfo = user;
                    $scope.notRegisteredUserInfoOrig = angular.copy($scope.notRegisteredUserInfo);

                    finalizeLoading();
                }, function (error) {
                    $scope.isLoading = false;
                });
            }
            else
            {
                loadUser().then(function () {
                    finalizeLoading();
                }, function (error) {
                    $scope.model = {};
                    $scope.isLoading = false;
                });
            }
        }, function (error) {
            $scope.model = {};
            $scope.isLoading = false;
        });
    }

    $scope.onAnonymousBtnClick = function () {
        if (!$scope.notRegisteredUserInfo) {
            $scope.notRegisteredUserInfo = notRegisteredUserSvc.createNew();
        }
        $scope.model.isNotRegisteredUser = true;
        $scope.model.userID = null;
        $scope.model.studentIds = [];
    }

    $scope.onExistingBtnClick = function () {
        $scope.model.isNotRegisteredUser = false;
        $scope.model.userID = null;
        $scope.model.studentIds = [""];

    }

    $scope.isFormValid = function () {
        return true;
    }

    $scope.detailIsUnchanged = function () {
        var modelEquals = angular.equals($scope.model, $scope.modelOrig);
        var userEquals = angular.equals($scope.notRegisteredUserInfo, $scope.notRegisteredUserInfoOrig);

        return modelEquals && userEquals;
    };


    $scope.isSaving = false;

    $scope.onDetailSave = function () {

        $scope.isSaving = true;

        var modelToSave = angular.copy($scope.model);

        var promisses = [];

        var modelEquals = angular.equals(modelToSave, $scope.modelOrig);
        var userEquals = angular.equals($scope.notRegisteredUserInfo, $scope.notRegisteredUserInfoOrig);

        if (modelToSave.isNew)
        {
            if (!!modelToSave.studentIds && !!modelToSave.studentIds.length && modelToSave.studentIds[0] == "") {
                modelToSave.studentIds = [];
            }

            if (!!modelToSave.notes && !!modelToSave.notes.length) {
                if (!modelToSave.notes[0].text && !modelToSave.notes[0].nextContactAtUtc) {
                    modelToSave.notes = null;
                }
            }

            if (!userEquals && !!$scope.notRegisteredUserInfo && modelToSave.isNotRegisteredUser) {
                notRegisteredUserSvc.insert($scope.notRegisteredUserInfo).$promise.then(function s(d) {

                    modelToSave.userId = d.id;
                    if (!!d.students && !!d.students.length) {
                        modelToSave.studentIds = [d.students[0].id];
                    }

                    leadSvc.insert(modelToSave).$promise.then(success, error);

                }, error);
            } else {
                leadSvc.insert(modelToSave).$promise.then(success, error);
            }
        }
        else 
        {
            if (!userEquals && !!$scope.notRegisteredUserInfo && modelToSave.isNotRegisteredUser) {
                if (!$scope.notRegisteredUserInfo.students || !$scope.notRegisteredUserInfo.students.length) {

                    if (!!modelToSave.studentIds && !!modelToSave.studentIds.length) {
                        modelToSave.studentIds = [];
                        modelEquals = false;
                    } 
                }               
            }

            if (!userEquals && modelToSave.isNotRegisteredUser) {
                notRegisteredUserSvc.update($scope.notRegisteredUserInfo).$promise.then(function s() {

                    if (!!$scope.notRegisteredUserInfo.students && !!$scope.notRegisteredUserInfo.students.length) {
                        if (!modelToSave.studentIds || !modelToSave.studentIds.length) {

                            // Fetch the id
                            notRegisteredUserSvc.getById($scope.notRegisteredUserInfo.id).$promise.then(function (d) {

                                if (!!d.students && !!d.students.length) {
                                    modelToSave.studentIds = [d.students[0].id];
                                    modelEquals = false;
                                }

                                if (!modelEquals) {
                                    leadSvc.update(modelToSave).$promise.then(success, error);
                                }

                            }, error);
                        }
                        else 
                        {
                            if (!modelEquals) {
                                leadSvc.update(modelToSave).$promise.then(success, error);
                            } else {
                                success();
                            }
                        }
                    }
                    else {
                        if (!modelEquals) {
                            leadSvc.update(modelToSave).$promise.then(success, error);
                        } else {
                            success();
                        }
                    }

                }, error);
            } else {
                if (!modelEquals) {
                    leadSvc.update(modelToSave).$promise.then(function s() {
                        if (!modelToSave.isNotRegisteredUser &&
                             $scope.modelOrig.isNotRegisteredUser &&
                             (modelToSave.leadSourceType == 2 || modelToSave.leadSourceType == 3 || modelToSave.leadSourceType == 4) &&
                             !!$scope.modelOrig.userId) {
                            notRegisteredUserSvc.remove($scope.modelOrig.userId).$promise.then(success, error);
                        } else {
                            success();
                        }
                    }, error);
                }
            }
        }


        function success() {
            $scope.isSaving = false;
            $scope.$hide();
            if (!!$scope.onLeadSave) {
                $scope.onLeadSave(modelToSave);
            }
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }
    }

    $scope.detailTabs = [{
        title: 'TXT_MAIN',
        template: "leads/leads-detail-main-tab.html"
    }, {
        title: 'TXT_LBL_USER',
        template: "leads/leads-detail-user-tab.html"
    }];

    if ($scope.model.isNew) {
        $scope.detailTabs.push({
            title: 'TXT_LBL_NOTES',
            template: "leads/leads-detail-notes-tab.html"
        });
    }

    $scope.detailTabs.activeTab = 0;


    $scope.onBindUserAndStudentClick = function() 
    {
        bindUserAndStudentDialogPromise.$promise.then(function () {
            bindUserAndStudentDialogPromise.$scope.notRegisteredUserInfo = $scope.notRegisteredUserInfo;
            bindUserAndStudentDialogPromise.$scope.onUserAndStudentAssigned = function (model) {
                $scope.model.userId = model.userID;
                $scope.model.studentIds = [model.studentID];
                $scope.model.isNotRegisteredUser = false;
                $scope.notRegisteredUserInfo = null;

                loadUser();
            };
            bindUserAndStudentDialogPromise.show();
        });
    }

    $scope.onChangeUserAndOrStudentClick = function()
    {
        bindUserAndStudentDialogPromise.$promise.then(function () {
            bindUserAndStudentDialogPromise.$scope.notRegisteredUserInfo = null;
            bindUserAndStudentDialogPromise.$scope.inputModel = {
                userID: $scope.model.userId,
                studentID: $scope.model.studentIds != null && $scope.model.studentIds.length > 0
                    ? $scope.model.studentIds[0]
                    : null
            };
            bindUserAndStudentDialogPromise.$scope.onUserAndStudentAssigned = function (model) {
                $scope.model.userId = model.userID;
                $scope.model.studentIds = [model.studentID];
                $scope.model.isNotRegisteredUser = false;
                $scope.notRegisteredUserInfo = null;

                loadUser();
            };
            bindUserAndStudentDialogPromise.show();
        });
    }

    var bindUserAndStudentDialogPromise = $modal({
        templateUrl: 'leads/leads/leads-bind-user-and-student-detail.html',
        show: false,       
        scope: $scope.$new()
    });

    if (!$scope.model.isNew) {
        loadData($scope.leadId);
    } else {
        $scope.isDisabled = false;
        $scope.onAnonymousBtnClick();
    }

}]);
